import { crudOperations } from './api';

const emailService = {
  /**
   * Send an email with optional attachments
   * @param {string} franchiseeId
   * @param {object} data - { customer_id, to_email, subject, message_html, cc_sender, documentLibraryIds, invoiceIds, guaranteeIds }
   */
  async sendEmail(franchiseeId, data) {
    try {
      // Use FormData to avoid ModSecurity blocking JSON POST bodies
      const formData = new FormData();
      formData.append('customer_id', data.customer_id || '');
      formData.append('job_id', data.job_id || '');
      formData.append('to_email', data.to_email);
      formData.append('subject', data.subject);
      formData.append('message_text', data.message_text || '');
      formData.append('cc_sender', data.cc_sender ? '1' : '0');
      formData.append('invoiceIds', JSON.stringify(data.invoiceIds || []));
      formData.append('guaranteeIds', JSON.stringify(data.guaranteeIds || []));
      formData.append('treatmentReportIds', JSON.stringify(data.treatmentReportIds || []));
      formData.append('documentLibraryIds', JSON.stringify(data.documentLibraryIds || []));
      // Attach images as actual file blobs
      if (data.imageAttachments) {
        for (const img of data.imageAttachments) {
          if (img.data) {
            const res = await fetch(img.data);
            const blob = await res.blob();
            formData.append('images', blob, img.name);
          }
        }
      }
      // Use upload() which sets correct multipart/form-data header (post() defaults to JSON)
      const response = await crudOperations.upload(`/emails/${franchiseeId}/send`, formData);
      return response.data;
    } catch (error) {
      console.error('Error sending email:', error);
      throw error;
    }
  },

  /**
   * List sent emails with pagination and search
   * @param {string} franchiseeId
   * @param {object} params - { page, limit, search }
   */
  async getEmails(franchiseeId, params = {}) {
    try {
      const response = await crudOperations.get(`/emails/${franchiseeId}`, params);
      return response.data;
    } catch (error) {
      console.error('Error fetching emails:', error);
      throw error;
    }
  },

  /**
   * Get emails sent to a specific customer
   * @param {string} franchiseeId
   * @param {string} customerId
   */
  async getCustomerEmails(franchiseeId, customerId) {
    try {
      const response = await crudOperations.get(`/emails/${franchiseeId}/customer/${customerId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching customer emails:', error);
      throw error;
    }
  },

  /**
   * Get single email with attachments
   * @param {string} franchiseeId
   * @param {string} emailId
   */
  async getEmailDetail(franchiseeId, emailId) {
    try {
      const response = await crudOperations.get(`/emails/${franchiseeId}/detail/${emailId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching email detail:', error);
      throw error;
    }
  }
};

export default emailService;
